import { Dispatch, SetStateAction, useState } from 'react';

interface IToggle {
  (): void;
}

interface IUseToggle {
  (initialValue: boolean): [
    boolean,
    IToggle,
    IToggle,
    IToggle,
    Dispatch<SetStateAction<boolean>>
  ];
}

const useToggle: IUseToggle = (initialState = false) => {
  const [value, setValue] = useState(initialState);

  const toggle: IToggle = () => setValue(!value);
  const setTrue: IToggle = () => setValue(true);
  const setFalse: IToggle = () => setValue(false);

  return [value, toggle, setTrue, setFalse, setValue];
};

export default useToggle;
